import { constantTree } from "../../../core/events/ConstantTree";

export const bookReturnJourneyTree = constantTree({
    BookReturnJourney: {
        Init: "",
        PassengerOutboundCheck: "",
        MainOutboundCheck: "",
        MainInboundCheck: "",
        BackToBookingClick: "",
        BookReturnJourneyRedirectClick: "",
        BookReturnJourneyContinueClick: "",
        DateSelector: {
            Change: ""
        },
        UpdateSelectedRange: "",
        UpdateSelectedBookReturnJourneyDate: "",
        UpdateInboundSelectedChangeDate: ""
    }
})